import Seat from './Seat';

export default class StandardOutdoorSeat extends Seat {
  constructor(threekitApi, options = {}) {
    super(threekitApi, options);

    this._key = 'standard_outdoor';
  }
}
